import React from "react";

const TestPage = () => {
  return (
    <div>
      <h1>test page</h1>
    </div>
  );
};
export default TestPage;
